import { track } from './analytics.js'
import { instance as funnelViewOpenedSeparatorsDbStore } from './funnelViewOpenedSeparatorsDbStore'

export function trackLastActiveSeparatorChanged(playbookId, actionCard, oldActionCard) {
  if (
    !actionCard.lastActiveSeparator ||
    actionCard.lastActiveSeparator <= 0 ||
    // if user clears some header-section, we make previous active header-section as lastActiveSeparator
    // but it doesn't mean that user has started editing of the section and we shouldn't track this change
    // so log scope's only if previous version of AC hasn't contain the separator among enabled
    (oldActionCard?.enabledSeparators?.some(x => x == actionCard.lastActiveSeparator) ?? false)
  ) {
    return
  }

  track('ac_activeScopeChanged', {
    playbookId: playbookId,
    lastActiveSeparator: actionCard.lastActiveSeparator,
  })
}

export async function trackFunnelViewSlideChanged(playbookId, openedSlideSeparatorId) {
  if (!openedSlideSeparatorId || openedSlideSeparatorId <= 0) {
    return
  }

  let openedSeparatorIds = await funnelViewOpenedSeparatorsDbStore.get(playbookId)

  if (!openedSeparatorIds) {
    openedSeparatorIds = []
  }
  if (openedSeparatorIds.indexOf(openedSlideSeparatorId) > -1) {
    return
  }
  openedSeparatorIds.push(openedSlideSeparatorId)
  await funnelViewOpenedSeparatorsDbStore.save(playbookId, openedSeparatorIds)
  track('ac_activeScopeChanged', {
    playbookId: playbookId,
    lastActiveSeparator: openedSlideSeparatorId,
  })
}

export function trackRequested(playbookId) {
  const eventData = {
    playbookId: playbookId,
  }
  addUTMParams(eventData)
  track('ac_requested', eventData)
}

export function trackSubmitted(playbookId, keywords) {
  const eventData = {
    playbookId: playbookId,
    keywords: keywords,
  }
  addUTMParams(eventData)
  track('ac_submitted', eventData)
}

function addUTMParams(eventData) {
  const params = new URLSearchParams(window.location.search)
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

  for (const key of utmKeys) {
    const value = params.get(key)
    if (value) {
      eventData[key] = value
    }
  }
  return eventData
}
